<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">گزارش اصلی کالیبراسیون</h5>
     <br/>
     <br/>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Certificate()" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table  class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره رسید</th>
              <th>نام مشتری</th>
              <th>کد مشتری</th>
              <th>نام دستگاه</th>
              <th>کد دستگاه</th>
              <th>سریال دستگاه</th>
              <th>مدت انقضاء</th>
              <th>اولویت</th>
              <th>مدت زمان کالیبراسیون (روز)</th>
              <th>توضیحات</th>
              <th>کاربر ایجاد کننده</th>
              <th>زمان ایجاد</th>
              <th>زمان ورود به آزمایشگاه</th>
              <th>زمان خروج از آزمایشگاه</th>
              <th>Certificate No</th>
              <th>Calibration Date</th>
              <th>Recal Date</th>
              <th>زمان بارگذاری گواهی نامه</th>
              <th>کاربر بارگذاری گواهی نامه</th>
              <th>زمان تحویل به مشتری</th>
              <th>کاربر تحویل به مشتری</th>
              <th>توضیحات تحویل</th>
              <th>وضیعت پرداخت</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Certificate
            | paginate
                    : {
                        id: 'Data_Seleted_Certificate',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Certificate).length
                      }
            ">
            <td>{{DataList_Certificate.indexOf(item)+1}}</td>
            <td>{{item.shomareh_recid}}</td>
            <td>{{item.customerName}}</td>
            <td>{{item.customerCode}}</td>
            <td>{{item.deviceName}}</td>
            <td>{{item.deviceCode}}</td>
            <td>{{item.deviceSerial}}</td>
            <td>{{item.expiration}}</td>
            <td>{{item.priority}}</td>
            <td>{{item.priod}}</td>
            <td>{{item.dsc}}</td>
            <td>{{item.create_user}}</td>
            <td>{{item.create_date}}</td>
            <td>{{item.downloadLab}}</td>
            <td>{{item.uploadLab}}</td>
            <td>{{item.certificate_No}}</td>
            <td>{{item.calibration_Date}}</td>
            <td>{{item.recal_Date}}</td>
            <td>{{item.create_subdate_certificate}}</td>
            <td>{{item.create_username_certificate}}</td>
            <td>{{item.create_subdate_delivery}}</td>
            <td>{{item.create_username_delivery}}</td>
            <td>{{item.dsc_delivery}}</td>
            <td>{{item.payed}}</td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="Data_Seleted_Certificate"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<table id="excel-table" style="display: none;" >
  <thead>
    <tr>
      <th>#</th>
      <th>شماره رسید</th>
      <th>نام مشتری</th>
      <th>کد مشتری</th>
      <th>نام دستگاه</th>
      <th>کد دستگاه</th>
      <th>سریال دستگاه</th>
      <th>مدت انقضاء</th>
      <th>اولویت</th>
      <th>مدت زمان کالیبراسیون (روز)</th>
      <th>توضیحات</th>
      <th>کاربر ایجاد کننده</th>
      <th>زمان ایجاد</th>
      <th>زمان ورود به آزمایشگاه</th>
      <th>زمان خروج از آزمایشگاه</th>
      <th>Certificate No</th>
      <th>Calibration Date</th>
      <th>Recal Date</th>
      <th>زمان بارگذاری گواهی نامه</th>
      <th>کاربر بارگذاری گواهی نامه</th>
      <th>زمان تحویل به مشتری</th>
      <th>کاربر تحویل به مشتری</th>
      <th>توضیحات تحویل</th>
      <th>وضیعت پرداخت</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Certificate">
    <td>{{DataList_Certificate.indexOf(item)+1}}</td>
    <td>{{item.shomareh_recid}}</td>
    <td>{{item.customerName}}</td>
    <td>{{item.customerCode}}</td>
    <td>{{item.deviceName}}</td>
    <td>{{item.deviceCode}}</td>
    <td>{{item.deviceSerial}}</td>
    <td>{{item.expiration}}</td>
    <td>{{item.priority}}</td>
    <td>{{item.priod}}</td>
    <td>{{item.dsc}}</td>
    <td>{{item.create_user}}</td>
    <td>{{item.create_date}}</td>
    <td>{{item.downloadLab}}</td>
    <td>{{item.uploadLab}}</td>
    <td>{{item.certificate_No}}</td>
    <td>{{item.calibration_Date}}</td>
    <td>{{item.recal_Date}}</td>
    <td>{{item.create_subdate_certificate}}</td>
    <td>{{item.create_username_certificate}}</td>
    <td>{{item.create_subdate_delivery}}</td>
    <td>{{item.create_username_delivery}}</td>
    <td>{{item.dsc_delivery}}</td>
    <td>{{item.payed}}</td>

    </tr>
  </tbody>
</table>


